import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~/client/components/base/arranger';
import TextField from '~/client/components/base/text-field';
import Button from '~c/components/base/button';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
  onSubmit: () => void;
}

const WizardDialogDemoContent: React.FC<Props> = ({ className, onSubmit }) => {
  return (
    <Arranger className={className} direction="column">
      <Text sz="body16">What are the project's details?</Text>
      <TextField label="Project name" />
      <TextField label="Description" multiline />

      <Button variant="contained" onClick={onSubmit}>
        Submit
      </Button>
    </Arranger>
  );
};

export default muiStyled(WizardDialogDemoContent)(
  ({ theme }) => css`
    margin: 0% 20%;
    > div {
      margin-bottom: ${theme.spacing(spc.xs)};
    }
    .MuiButton-root.MuiButton-contained {
      width: 100%;
    }
  `
);
